export default "__VITE_ASSET__BAYVbTIp__"